import { useTranslation } from "react-i18next";
import { useTowns } from "@hooks";
import { Select, SelectProps } from "antd";
import { observer } from "mobx-react";
import { useMemo } from "react";

declare const abp: any;

type TownSelectProps = Omit<SelectProps, "options">;

const TownSelectComponent: React.FC<TownSelectProps> = (props) => {
  const { t } = useTranslation();
  const { towns } = useTowns();
  const lang = abp.localization?.currentLanguage?.name || "sr";

  const options = useMemo(
    () =>
      towns.map((t) => ({
        value: t.id,
        label: lang === "en" ? t.nameEn : t.nameSr,
      })),
    [towns, lang],
  );

  return (
    <Select
      allowClear
      showSearch
      placeholder={t("SelectTown")}
      options={options}
      {...props}
      style={{ textAlign: "left", ...props.style }}
    />
  );
};

export const TownSelect = observer(TownSelectComponent);
